export default {
    topics: [
        {
            title: ' getEventFromTransition ',
            href: 'f-getEventFromTransition.html',
            attributes: { 'data-id': 'f-getEventFromTransition' },
            menu: { hasChildren: false },
            tocID: 'f-getEventFromTransition-d66e4843',
            topics: [],
        },
        {
            title: ' evaluateTemplate ',
            href: 'f-evaluateTemplate.html',
            attributes: { 'data-id': 'f-evaluateTemplate' },
            menu: { hasChildren: false },
            tocID: 'f-evaluateTemplate-d66e4851',
            topics: [],
        },
    ],
};

